import { render, staticRenderFns } from "./RoiHistory.vue?vue&type=template&id=ff275a50&"
import script from "./RoiHistory.vue?vue&type=script&lang=js&"
export * from "./RoiHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports